import { render, staticRenderFns } from "./topic_sel_model_dialog.vue?vue&type=template&id=f42b7272"
import script from "./topic_sel_model_dialog.vue?vue&type=script&lang=js"
export * from "./topic_sel_model_dialog.vue?vue&type=script&lang=js"
import style0 from "./topic_sel_model_dialog.vue?vue&type=style&index=0&id=f42b7272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports